import DropzoneField from './DropzoneField.component';

export default DropzoneField;
